import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { realEstateOwnershipTypeOptions } from '@app/forms/subscription/services/ref';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'real-estate-owner-ship-type',
    templateUrl: './real-estate-owner-ship-type.component.html',
    styleUrls: ['./real-estate-owner-ship-type.component.scss'],
    standalone: false
})
export class RealEstateOwnerShipTypeComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = realEstateOwnershipTypeOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
